<template>
  <v-flex>
    <div v-if="jwt.role_id === 100 || jwt.role_id === 200" class="mb-6">
      <v-btn to="/user/create" color="orange">新增</v-btn>
    </div>

    <v-data-table :headers="thead" :items="users" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.user_id="{ item }">
        <v-btn :to="`/user/${item.user_id}`" outlined color="blue">檢視/修改</v-btn>
      </template>
    </v-data-table>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import userApi from "@/api/user";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      users: [],

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "名稱",
          value: "username"
        },
        {
          text: "帳號信箱",
          value: "email"
        },
        {
          text: "權限角色",
          value: "role"
        },
        {
          text: "最近上線時間",
          value: "last_logon_time",
          align: "center",
          width: "165px"
        },
        {
          text: "帳號狀態",
          value: "account_status",
          align: "center"
        },
        {
          text: "",
          value: "user_id"
        }
      ]
    };
  },

  computed: {
    ...mapState("admin", ["jwt"])
  },
  watch: {},
  methods: {},

  mounted() {
    userApi
      .getAll()
      .then(res => {
        this.users = res.users;

        this.users.forEach((item, idx) => {
          item.no = idx + 1;
        });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
